(() => {
  if (window.__smCartDrawerInlinePoc) return;
  window.__smCartDrawerInlinePoc = true;

  const scriptConfig = document.currentScript?.dataset || {};
  const discountCombineInvalidMessage = scriptConfig.discountCombineInvalid || '';
  const enterCodeAtCheckoutMessage = scriptConfig.enterCodeAtCheckout || '';
  const giftCardInvalidMessage = scriptConfig.giftCardInvalid || '';
  const enableShippingProgress = scriptConfig.enableShippingProgress === 'true';
  let currentCartItemCount = Number(
    scriptConfig.cartCount || document.getElementById('CartDrawer-ItemCount')?.textContent || 0
  );

  function getMiniCartFastSimonUpsells() {
    return document.querySelectorAll(
      'cart-drawer-items [class^="fast-simon-new-upsell-"], cart-drawer-items [class^="fast-simon-upsell-"]'
    );
  }

  function setMiniCartFastSimonUpsellsEnabled(enabled) {
    getMiniCartFastSimonUpsells().forEach((upsell) => {
      if (!upsell.dataset.smOriginalDataSettings && upsell.hasAttribute('data-settings')) {
        upsell.dataset.smOriginalDataSettings = upsell.getAttribute('data-settings');
      }

      if (enabled) {
        if (upsell.dataset.smOriginalDataSettings && !upsell.hasAttribute('data-settings')) {
          upsell.setAttribute('data-settings', upsell.dataset.smOriginalDataSettings);
        }
        upsell.hidden = false;
        upsell.removeAttribute('aria-hidden');
        upsell.style.removeProperty('display');
        upsell.style.removeProperty('min-height');
        return;
      }

      upsell.removeAttribute('data-settings');
      upsell.hidden = true;
      upsell.setAttribute('aria-hidden', 'true');
      upsell.style.setProperty('display', 'none', 'important');
      upsell.style.setProperty('min-height', '0', 'important');
    });
  }

  function syncMiniCartFastSimonUpsells(cart) {
    if (cart && typeof cart.item_count === 'number') {
      currentCartItemCount = cart.item_count;
    } else {
      const itemCount = Number(document.getElementById('CartDrawer-ItemCount')?.textContent || NaN);
      if (Number.isFinite(itemCount)) currentCartItemCount = itemCount;
    }

    setMiniCartFastSimonUpsellsEnabled(currentCartItemCount > 0);
  }

  function scheduleMiniCartFastSimonUpsellSync(cart) {
    syncMiniCartFastSimonUpsells(cart);
    [100, 500, 1500, 3000].forEach((delay) => {
      setTimeout(() => syncMiniCartFastSimonUpsells(), delay);
    });
  }

  scheduleMiniCartFastSimonUpsellSync({ item_count: currentCartItemCount });

  window.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cart-sidebar-discount.floating-label').forEach(function(container) {
      var input = container.querySelector('#discount-code-input');
      if (!input) return;

      if (input.value !== '') {
        container.classList.add('is-floating');
      }

      input.addEventListener('focus', function() {
        container.classList.add('has-focus');
        container.classList.add('is-floating');
      });

      input.addEventListener('blur', function(e) {
        container.classList.remove('has-focus');
        if (e.target.value === '') {
          container.classList.remove('is-floating');
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Select all elements with the class 'cart-item__details'
    var cartItems = document.querySelectorAll('.cart-item__details');

    cartItems.forEach(function (cartItem) {
      // Find the anchor tag within the current cart item
      var anchor = cartItem.querySelector('.cart-item__name');

      // Check if the anchor text is 'DIGITAL GIFT CARD'
      if (anchor && anchor.textContent.trim() === 'DIGITAL GIFT CARD') {
        // Find the '.product_option_details' div within the current cart item
        var productOptionDetails = cartItem.querySelector('.product_option_details');

        // Hide the '.product_option_details' div if it exists
        if (productOptionDetails) {
          productOptionDetails.style.display = 'none';
        }
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return msie > 0 || trident > 0;
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function (event) {
      document.querySelector('#cart').submit();
    });
  });

  function getDiscountValue(wrapper) {
    return {
      title: wrapper.querySelector('.title').textContent,
      value: wrapper.querySelector('.value').textContent,
    };
  }

  function renderAppliedDiscounts(cartDiscounts, productDiscounts) {
    const appliedDiscountContainer = document.querySelector('#applied-discount-code');
    if (!appliedDiscountContainer) return;
  
    appliedDiscountContainer.innerHTML = '';
  
    const appliedTitles = new Set();
  
    [...cartDiscounts, ...productDiscounts].forEach(discount => {
      const value = getDiscountValue(discount);
      const title = value.title.trim();
      const amount = value.value.trim();
  
      if (!appliedTitles.has(title)) {
        appliedTitles.add(title);
  
        const wrapper = document.createElement('span');
        wrapper.classList.add('applied-discount-code-wrapper');
        wrapper.style.display = 'inline-flex';
        wrapper.style.alignItems = 'center';
        wrapper.style.marginBottom = '6px';
  
        const valueSpan = document.createElement('span');
        valueSpan.classList.add('applied-discount-code-value');
        valueSpan.textContent = `${title} (-${amount})`;
  
        const clearBtn = document.createElement('button');
        clearBtn.classList.add('clear-discount-btn');
        clearBtn.textContent = 'X';
        clearBtn.style.marginLeft = '8px';
        clearBtn.addEventListener('click', async function () {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
          await updateDicounts();
        });
  
        wrapper.appendChild(valueSpan);
        wrapper.appendChild(clearBtn);
        appliedDiscountContainer.appendChild(wrapper);
      }
    });
  }
  

  async function updateDicounts() {
    const res = await fetch("/?render_id=header-minicart");
    const text = await res.text();
    // Inert parse — no custom-element upgrades, so the fetched header doesn't leak.
    const html = new DOMParser().parseFromString(text, "text/html");
    const newItems = html.querySelector("#CartDrawer").querySelector(".drawer__inner cart-drawer-items .cart-items").innerHTML
    const newPrice = html.querySelector("#CartDrawer").querySelector(".drawer__footer").querySelector(".cart-drawer__footer").innerHTML;

    const discounts = html.querySelector("#cart-discounts");
    const cartDiscounts = discounts ? discounts.querySelectorAll(".discount-cart") : [];
    const productDiscounts = discounts ? discounts.querySelectorAll(".discount-product") : [];
    let discountCodeValue = document.querySelector('#applied-discount-code .applied-discount-code-value');

    // Display discount details from the backend response
    renderAppliedDiscounts(cartDiscounts, productDiscounts);

    document.querySelector("#CartDrawer").querySelector(".drawer__inner cart-drawer-items .cart-items").innerHTML = newItems;
    document.querySelector("#CartDrawer").querySelector(".drawer__footer").querySelector(".cart-drawer__footer").innerHTML = newPrice;
  }
  //we need to call this on dom content loaded and cart update
  function initializeDiscountCode() {
    if (window.__ff_skip_discount_init) return;

    let clearBtn = document.querySelector('#clear-discount-btn');
    let discountCodeError = document.querySelector('#discount-code-error');
    let discountCodeWrapper = document.querySelector('#applied-discount-code .applied-discount-code-wrapper');
    let discountCodeValue = document.querySelector('#applied-discount-code .applied-discount-code-value');

    const discounts = document.querySelector("#cart-discounts");
    if (discounts) {
      const cartDiscounts = discounts.querySelectorAll(".discount-cart");
      const productDiscounts = discounts.querySelectorAll(".discount-product");
      renderAppliedDiscounts(cartDiscounts, productDiscounts);
    }

    document.querySelectorAll('.cart-sidebar-discount').forEach(function(container) {
      if (container.dataset.discountBound === 'true') return;
      container.dataset.discountBound = 'true';

      let applyBtn = container.querySelector('#apply-discount-btn');
      let discountCodeInput = container.querySelector('#discount-code-input');

      if (!applyBtn || !discountCodeInput) return;

      toggleApplyButtonState();

      discountCodeInput.addEventListener('input', toggleApplyButtonState);

      discountCodeInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (discountCodeInput.value.trim() !== '') {
            applyDiscount(discountCodeInput.value);
          }
        }
      });

      applyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (discountCodeInput.value.trim() !== '') {
          applyDiscount(discountCodeInput.value);
        }
      });

      function toggleApplyButtonState() {
        if (discountCodeInput.value.trim() === '') {
          applyBtn.disabled = true;
          applyBtn.style.pointerEvents = 'none';
        } else {
          applyBtn.disabled = false;
          applyBtn.style.pointerEvents = 'all';
        }
      }

      async function applyDiscount(discountCode) {
        if (!discountCode) {
          handleInvalidDiscount(discountCode);
          return;
        }

        if (applyBtn) {
          applyBtn.innerHTML = "<div class='loader'></div>";
          applyBtn.style.pointerEvents = 'none';
          discountCodeInput.value = '';
        }

        try {
          const response = await fetch(`/discount/${encodeURIComponent(discountCode)}`);
          const responseText = await response.text();
          // Inert parse — no custom-element upgrades, so the fetched page doesn't leak.
          const html = new DOMParser().parseFromString(responseText, "text/html");

          const discounts = html.querySelector("#cart-discounts");
          const cartDiscounts = discounts ? discounts.querySelectorAll(".discount-cart") : [];
          const productDiscounts = discounts ? discounts.querySelectorAll(".discount-product") : [];

          if (response.ok) {
            const appliedDiscountValue = document.querySelector('.applied-discount-code-value');

            if (appliedDiscountValue && appliedDiscountValue.textContent.trim() !== '') {
              const currentDiscountText = appliedDiscountValue.textContent.trim();
              const currentAmountMatch = currentDiscountText.match(/\(-([^)]+)\)/);
              const currentAmount = currentAmountMatch ? extractNumericAmount(currentAmountMatch[1]) : 0;

              let newAmount = 0;
              if (cartDiscounts.length > 0) {
                const discountValue = getDiscountValue(cartDiscounts[0]);
                newAmount = extractNumericAmount(discountValue.value);
              } else if (productDiscounts.length > 0) {
                const discountValue = getDiscountValue(productDiscounts[0]);
                newAmount = extractNumericAmount(discountValue.value);
              }

              if (newAmount <= currentAmount) {
                if (discountCodeError) {
                  discountCodeError.innerHTML = discountCode + ' ' + discountCombineInvalidMessage;
                  discountCodeError.style.color = '#EB001B';
                }
                discountCodeInput.value = '';
                setTimeout(() => {
                  if (discountCodeError) discountCodeError.innerHTML = '';
                  discountCodeInput.focus();
                }, 3000);
                return;
              }
            }

            if (discountCodeWrapper) {
              discountCodeWrapper.style.display = 'inline-flex';
            }

            if (cartDiscounts.length > 0 && discountCodeValue) {
              const discountValue = getDiscountValue(cartDiscounts[0]);
              discountCodeValue.innerHTML = discountValue.title + ' (-' + discountValue.value + ')';
            }

            if (productDiscounts.length > 0 && discountCodeValue) {
              const discountValue = getDiscountValue(productDiscounts[0]);
              discountCodeValue.innerHTML = discountValue.title + ' (-' + discountValue.value + ')';
            }

            if (productDiscounts.length > 0 || cartDiscounts.length > 0) {
              if (discountCodeError) {
                discountCodeError.innerHTML = '';
              }
              container.classList.remove('is-floating');
              toggleApplyButtonState();
              await updateDicounts();
              if (enableShippingProgress) await refreshShippingProgressQuietly();
            } else {
              handleInvalidDiscount(discountCode);
            }
          } else {
            handleInvalidDiscount(discountCode);
          }
        } catch (error) {
          console.error('Error:', error);
        } finally {
          if (applyBtn) {
            applyBtn.innerHTML = 'Apply';
            applyBtn.style.pointerEvents = 'all';
          }
        }
      }

      function handleInvalidDiscount(code = '') {
        if (discountCodeValue) discountCodeValue.innerHTML = '';
        clearLocalStorage();

        const isLikelyGiftCard = code.trim().length === 15;

        if (discountCodeError) {
          discountCodeError.innerHTML = isLikelyGiftCard
            ? enterCodeAtCheckoutMessage
            : giftCardInvalidMessage;
        }

        setTimeout(() => {
          if (discountCodeError) discountCodeError.innerHTML = '';
          discountCodeInput.value = '';
          discountCodeInput.focus();
          toggleApplyButtonState();
        }, 3000);
      }
    });

    if (clearBtn && !clearBtn.dataset.bound) {
      clearBtn.dataset.bound = 'true';
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        clearDiscount();
      });
    }

    async function clearDiscount() {
      if (discountCodeValue) discountCodeValue.innerHTML = '';
      if (discountCodeError) discountCodeError.innerHTML = '';
      clearLocalStorage();

      await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });

      await updateDicounts();
      if (enableShippingProgress) await refreshShippingProgressQuietly();
    }

    function clearLocalStorage() {
      if (discountCodeWrapper) discountCodeWrapper.style.display = 'none';
    }

    function extractNumericAmount(moneyString) {
      const numericMatch = moneyString.match(/[\d.]+(?:[,.][\d]{2})?/);
      if (numericMatch) {
        return parseFloat(numericMatch[0].replace(/[.,]/g, function(match) {
          return match === ',' ? '.' : '';
        }));
      }
      return 0;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeDiscountCode();
    scheduleMiniCartFastSimonUpsellSync();
  });
  document.addEventListener('cart-update', (event) => {
    initializeDiscountCode();
    scheduleMiniCartFastSimonUpsellSync(event.detail?.cart);
  });

  const updateUpsell = () => {
    setTimeout(() => {
      initializeDiscountCode();
      scheduleMiniCartFastSimonUpsellSync();
    }, 3000);
  };

  document.addEventListener('fs-custom-events-add-to-cart-response', updateUpsell);

  (function(){
    var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    var RE=/\/cart\/(add|change|update|clear)(?:\.js)?/i;
    function refreshCount(){
      fetch(ROOT+'cart.js?ts='+Date.now(),{credentials:'same-origin',cache:'no-store'})
        .then(r=>r.json())
        .then(cart=>{
          var el=document.getElementById('CartDrawer-ItemCount');
          if(el) el.textContent=(cart&&typeof cart.item_count==='number')?cart.item_count:0;
          syncMiniCartFastSimonUpsells(cart);
          try{document.dispatchEvent(new CustomEvent('cart-update',{detail:{cart,source:'count'}}));}catch(e){}
        })
        .catch(()=>{});
    }
    document.addEventListener('DOMContentLoaded', refreshCount);
    var _fetch=window.fetch;
    window.fetch=function(input,init){
      var p=_fetch.apply(this,arguments);
      try{
        var url=(typeof input==='string')?input:(input&&input.url);
        if(url&&RE.test(url)) p.then(()=>setTimeout(refreshCount,120));
      }catch(e){}
      return p;
    };
    var _send=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send=function(){
      this.addEventListener('load',()=>{
        try{ if(this.responseURL&&RE.test(this.responseURL)) setTimeout(refreshCount,120); }catch(e){}
      });
      return _send.apply(this,arguments);
    };
  })();

  async function refreshShippingProgressQuietly(){
    if (!enableShippingProgress) return;
      try {
        const r = await fetch('/cart.js?ts=' + Date.now(), { cache: 'no-store' });
        const cart = await r.json();
        const total =
          (cart.original_total_price ?? cart.items_subtotal_price ?? cart.total_price) -
          (cart.total_discount ?? 0);

        window.__ff_skip_discount_init = true;
        document.dispatchEvent(new CustomEvent('cart-update', {
          detail: { cart: { ...cart, total_price: Math.max(0, total) }, __shippingPing: true }
        }));

        setTimeout(() => { window.__ff_skip_discount_init = false; }, 0);
      } catch(e){ console.warn(e); }
  }

})();
